import { AUTHORITIES } from 'app/config/constants';
import PrivateRoute from 'app/shared/auth/private-route';
import React from 'react';
import { Switch } from 'react-router-dom';
import Sensor from './sensor';
import SensorDeleteDialog from './sensor-delete-dialog';
import SensorDetail from './sensor-detail';
import SensorUpdate from './sensor-update';



const Routes = ({ match }) => (
  <>
    <Switch>
      <PrivateRoute exact path={`${match.url}/new`} component={SensorUpdate} hasAnyAuthorities={[AUTHORITIES.ADMIN]} />
      <PrivateRoute exact path={`${match.url}/:id/edit`} component={SensorUpdate} hasAnyAuthorities={[AUTHORITIES.ADMIN]} />
      <PrivateRoute exact path={`${match.url}/:id`} component={SensorDetail} hasAnyAuthorities={[AUTHORITIES.ADMIN]} />
      <PrivateRoute path={match.url} component={Sensor} hasAnyAuthorities={[AUTHORITIES.ADMIN]} />
    </Switch>
    <PrivateRoute exact path={`${match.url}/:id/delete`} component={SensorDeleteDialog} hasAnyAuthorities={[AUTHORITIES.ADMIN]} />
  </>
);

export default Routes;
